import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import logo from '../Assets/img/logo.png';
import msg from '../Assets/img/logo.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MessageIcon from '@mui/icons-material/Message';
import MenuIcon from '@mui/icons-material/Menu';
import ImpersonationBanner from './ImpersonationBanner';
import Api from "./Api";

import Header from './Header';

import { useLocation } from 'react-router-dom';

import '../Assets/css/vendors/newsidebar.css';
import '../Assets/css/style.css';
import '../Assets/css/vendors/loader.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import '../Assets/css/vendors/themify.css';

const Template = ({ children }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [menuData, setMenuData] = useState([]);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [activeNestMenu, setActiveNestMenu] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [toggleFullscreen, setToggleFullscreen] = useState(false);
    const messageCount = 5;
    //used to fetch menu and select the active menu by defualt
    const college_id = localStorage.getItem('collegeid');

    const [time, setTime] = useState(""); // State to hold the IST time {/*Nov 16*/}

    useEffect(() => {
        const fetchMenuData = async () => {
            const { http } = Api();
            try {
                const response = await http.get('getusermenus');
                if (response.data && response.data.menus) {
                    setMenuData(response.data.menus);
                    const activeMenuItem = response.data.menus.find(menuItem => {
                        const currentPath = location.pathname.substring(1);
                        const menuUrl = menuItem.url;
                        
                        // Exact match for root paths
                        if (currentPath === menuUrl) {
                            return true;
                        }
                        
                        // For nested routes, check if current path starts with menu URL
                        // but handle cases where menu URLs might be substrings of each other
                        if (menuUrl && currentPath.startsWith(menuUrl + '/')) {
                            return true;
                        }
                        
                        return false;
                    });
                    if (activeMenuItem) {
                        if (activeMenuItem.parent_id) {
                            const parentMenuItem = response.data.menus.find(menuItem => menuItem.id === activeMenuItem.parent_id);
                            if (parentMenuItem && parentMenuItem.parent_id) {
                                setActiveSubMenu(parentMenuItem.parent_id);
                                setActiveNestMenu(activeMenuItem.parent_id);
                            } else {
                                setActiveSubMenu(activeMenuItem.parent_id);
                                setActiveNestMenu(activeMenuItem.id);
                            }
                        }
                        else if (activeMenuItem.id === 4 || activeMenuItem.id === 2) {

                            setActiveSubMenu(activeMenuItem.id);
                        }
                    }
                }
            } catch (error) {
                console.error('Error fetching menu data:', error);
                if (college_id == 0) {
                    navigate("/admin/");
                }
                else {
                    navigate("/college");
                }
            }
        };

        fetchMenuData();
    }, [location.pathname, navigate]);


    //for sub menu
    const handleSubMenuClick = (menuId, url) => {
        if (url === "/null") {
            setActiveSubMenu(activeSubMenu === menuId ? null : menuId);
        } else {
            navigate(url);
        }
    };

    const handleToggleFullscreen = () => {
        setToggleFullscreen(!toggleFullscreen);
    };

    //for nest menu
    const handleNestmenuclick = (menuId, url) => {

        if (url === "/null") {
            setActiveNestMenu(activeNestMenu === menuId ? null : menuId);
        } else {
            navigate(url);
        }
    };

    //for side bar
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleLogout = () => {

        const userType = localStorage.getItem("usertype");

        const { http } = Api();
        http.get('logout').then(response => {

            if (response.data.status_code === 'MSG6') {

                console.log('Token revoked successfully');
                sessionStorage.removeItem('message');
                localStorage.clear();
                //window.location.reload();

                if (userType == 21) {
                    navigate("/bos");
                }
                else if (userType == 22) {
                    navigate("/sfa");
                }
                else if (userType == 27) {
                    navigate("/is");
                }
                else if (userType == 28) {
                    navigate("/convenor");
                }
                else if (userType == 24) {
                    navigate("/ino");
                }
                else if (college_id == 0) {
                    navigate("/admin");
                }
                else {
                    navigate("/college");
                }
            }
        }).catch(error => {

            sessionStorage.removeItem("message");
            localStorage.clear();
            window.location.reload();

        });
    };

    return (
        <div>
            <Header logo={logo} handleLogout={handleLogout} />

            {/* sidebar */}

            <div className="container-fluid">
                <div className="row">

                    {/* menu icon on mobile screen  */}

                    <div className="d-md-none">
                        <button className="mobile-menu-toggle12 pos-icn position-fixed" style={{ top: '10px', right: '10px' }} onClick={toggleSidebar}>
                            <MenuIcon />
                        </button>
                    </div>

                    {/* logic to render menu and submenu from server - hide in fullscreen */}

                    <div className={`col-auto col-md-3 col-xl-2 px-sm-2 px-0 sidebar activity-scroll-bar-container activity-scroll-bar-container-ht ${sidebarOpen ? 'show' : ''} ${toggleFullscreen ? 'd-none' : ''}`}>
                        <div className="d-flex flex-column align-items-start pt-2 text-dark vh-100">
                            <ul className="nav flex-column align-items-start" id="menu">
                                {menuData
                                    .filter(menuItem => menuItem.parent_id === null && menuItem.status === "active")
                                    .sort((a, b) => a.order - b.order)
                                    .map(menuItem => (
                                        <li className="nav-item-side main-menu-item" key={menuItem.id}>
                                            <div
                                                className={`nav-link-side ${location.pathname === `/${menuItem.url}` || location.pathname.startsWith(`/${menuItem.url}/`) || activeSubMenu === menuItem.id ? 'active' : ''}`}
                                                onClick={() => handleSubMenuClick(menuItem.id, `/${menuItem.url}`)}
                                            >
                                                <i className={`bi bi-${menuItem.icon} nav_icon`}></i>
                                                <span className="nav_name">{menuItem.label}</span>
                                                {menuData.some(item => item.parent_id === menuItem.id) && (
                                                    <ExpandMoreIcon
                                                        className={`nav_icon ${activeSubMenu === menuItem.id ? 'rotate' : ''}`}
                                                        style={{ marginLeft: 'auto' }}
                                                    />
                                                )}
                                            </div>
                                            {activeSubMenu === menuItem.id && (
                                                <ul className="submenu sider activity-scroll-container activity-scroll-bar-container " style={{ maxHeight: 'none' }}>
                                                    {menuData
                                                        .filter(submenuItem => submenuItem.parent_id === menuItem.id && submenuItem.status === "active")
                                                        .sort((a, b) => a.order - b.order)
                                                        .map(submenuItem => (
                                                            <li className="sub-nav-item" key={submenuItem.id}>
                                                                <div className={`nav-link-side-sub ${location.pathname === `/${submenuItem.url}` || location.pathname.startsWith(`/${submenuItem.url}/`) || activeNestMenu === submenuItem.id ? 'active' : ''}`} onClick={() => handleNestmenuclick(submenuItem.id, `/${submenuItem.url}`)} >
                                                                    <i className={`bi bi-${submenuItem.icon} nav_icon`}></i>
                                                                    <span className="nav_name1">{submenuItem.label}</span>
                                                                    {menuData.some(item => item.parent_id === submenuItem.id) && (
                                                                        <ExpandMoreIcon
                                                                            className={`nav_icon ${activeNestMenu === submenuItem.id ? 'rotate1' : ''}`}
                                                                            style={{ marginLeft: 'auto' }}
                                                                        />
                                                                    )}
                                                                </div>

                                                                {activeNestMenu === submenuItem.id && (
                                                                    <ul className={`nestmenu sider ${activeNestMenu === submenuItem.id ? 'active' : ''}`}>
                                                                        {menuData
                                                                            .filter(nestmenuItem => nestmenuItem.parent_id === submenuItem.id && nestmenuItem.status === "active")
                                                                            .map(nestmenuItem => (
                                                                                <li className="sub-nav-item" key={nestmenuItem.id}>


                                                                                    <div className={`nav-link-side-sub1 ${location.pathname === `/${nestmenuItem.url}` || location.pathname.startsWith(`/${nestmenuItem.url}/`) ? 'active' : ''}`} onClick={() => handleNestmenuclick(nestmenuItem.id, `/${nestmenuItem.url}`)} >
                                                                                        <i className={`bi bi-${nestmenuItem.icon} nav_icon`}></i>
                                                                                        <span className="nav_name12">{nestmenuItem.label}</span>
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>

                    {/* Main content - expand to full width when sidebar is hidden */}
                    <div className={toggleFullscreen ? 'col-12 py-3 content-scroll45' : 'col py-3 content-scroll45'}>
                        <div className="card-body pt-5 activity-scroll-container activity-scroll-bar-container clg-card-ht2 scrollable-bar-wt">
                            <button
                                className={`js-toggle-fullscreen-btn toggle-fullscreen-btn ${toggleFullscreen ? 'on' : ''} d-none d-md-block`}
                                aria-label={toggleFullscreen ? "Show sidebar" : "Hide sidebar"}
                                onClick={handleToggleFullscreen}>
                                <svg className="toggle-fullscreen-svg" width="28" height="28" viewBox="-2 -2 28 28">
                                    <g className="icon-fullscreen-enter">
                                        <path d="M 2 9 v -7 h 7" />
                                        <path d="M 22 9 v -7 h -7" />
                                        <path d="M 22 15 v 7 h -7" />
                                        <path d="M 2 15 v 7 h 7" />
                                    </g>

                                    <g className="icon-fullscreen-leave">
                                        <path d="M 24 17 h -7 v 7" />
                                        <path d="M 0 17 h 7 v 7" />
                                        <path d="M 0 7 h 7 v -7" />
                                        <path d="M 24 7 h -7 v -7" />
                                    </g>
                                </svg>
                            </button>
                            <ImpersonationBanner />
                            {children}
                        </div>
                    </div>
                </div>
            </div>

            {/* footer  */}

            <footer className="footer footer-fixinside" style={{ height: "60px" }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 footer-copyright text-center">
                            <p className="mb-0 ml">© Mahatma Gandhi University, Priyadarsini Hills, Kottayam, Kerala, India - 686560</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template;